import { Icon } from "@introist/react-foundation/v2";
import { AppMenuItem } from "../shell";
import { AI_STUDIO_ROUTES } from "../../../ai-studio";

export const useAIStudioMenuItems = (
  handleItemClick: (to: string) => (e: React.MouseEvent) => unknown
) => {
  let items: AppMenuItem[] = [];

  items.push({
    title: "Agents",
    icon: <Icon name="robot" />,
    path: AI_STUDIO_ROUTES.agents.path,
    onClick: handleItemClick(AI_STUDIO_ROUTES.agents.path),
    divider: true
  });

  items.push({
    title: "Channels",
    icon: <Icon name="comment" />,
    path: AI_STUDIO_ROUTES.channels.path,
    onClick: handleItemClick(AI_STUDIO_ROUTES.channels.path)
  });

  items.push({
    title: "Knowledge",
    icon: <Icon name="book" />,
    path: AI_STUDIO_ROUTES.knowledgeSources.path,
    onClick: handleItemClick(AI_STUDIO_ROUTES.knowledgeSources.path),
    divider: true
  });

  items.push({
    title: "Users",
    icon: <Icon name="persons" />,
    path: AI_STUDIO_ROUTES.users.path,
    onClick: handleItemClick(AI_STUDIO_ROUTES.users.path)
  });

  return items;
};
